import React from 'react';
import { Link } from 'react-router-dom';
import mpsLogo from '../../assets/images/mps_logo.png';

const LIBERATE_SITE = 'https://www.liberateglobal.com/';

const LandingLogo = ({
  to = '/',
  variant = 'light',
  layout = 'lockup',
  showProductName = true,
  showParentLink = false,
  size = 'md',
  className = '',
}) => {
  const isOnDark = variant === 'dark';
  const heights = { sm: 28, md: 36, lg: 44 };
  const logoHeight = heights[size] || heights.md;

  const productBlock = showProductName && (
    <div className="landing-brand-product min-w-0">
      <p
        className={`landing-brand-product-name mb-0 ${
          size === 'lg' ? 'fs-4' : size === 'sm' ? 'fs-6' : 'fs-5'
        } ${isOnDark ? 'text-white' : 'text-dark'}`}
      >
        Enable LXP
      </p>
      <p className={`landing-brand-product-tag mb-0 ${isOnDark ? 'text-white-50' : 'text-secondary'}`}>
        Learning Experience Platform
      </p>
    </div>
  );

  const logoImage = (
    <img
      src={mpsLogo}
      alt="Liberate Global"
      className="landing-brand-logo-img object-contain"
      style={{ height: logoHeight, width: 'auto', maxWidth: size === 'lg' ? 160 : 130 }}
    />
  );

  const content =
    layout === 'logo-only' ? (
      <div className={`landing-brand-logo-only ${className}`}>{logoImage}</div>
    ) : (
      <div className={`landing-brand-lockup ${isOnDark ? 'landing-brand-on-dark' : ''} ${className}`}>
        <div className="landing-brand-parent shrink-0">
          {showParentLink ? (
            <a
              href={LIBERATE_SITE}
              target="_blank"
              rel="noopener noreferrer"
              className="text-decoration-none d-inline-block"
              aria-label="Liberate Global — parent company"
              onClick={(e) => e.stopPropagation()}
            >
              {logoImage}
            </a>
          ) : (
            logoImage
          )}
          {showParentLink && (
            <span className={`landing-brand-parent-label ${isOnDark ? 'text-white-50' : 'text-secondary'}`}>
              A Liberate Global company
            </span>
          )}
        </div>

        {showProductName && (
          <>
            <span className={`landing-brand-divider ${isOnDark ? 'landing-brand-divider-dark' : ''}`} aria-hidden="true" />
            {productBlock}
          </>
        )}
      </div>
    );

  if (to) {
    return (
      <Link to={to} className="landing-brand-link no-underline" aria-label="Enable LXP home">
        {content}
      </Link>
    );
  }

  return content;
};

export default LandingLogo;
